import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["data-bs-target"]
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered mw-500px" }
const _hoisted_4 = { class: "modal-content rounded-3 umt-form" }
const _hoisted_5 = { class: "modal-header border-0 px-6 pt-5 pb-0" }
const _hoisted_6 = { class: "svg-icon svg-icon-2" }
const _hoisted_7 = { class: "modal-body px-6 pt-0 pb-6" }
const _hoisted_8 = { class: "text-center mb-5" }
const _hoisted_9 = { class: "symbol symbol-circle symbol-60px mx-auto mb-4" }
const _hoisted_10 = { class: "symbol-label bg-light-danger" }
const _hoisted_11 = { class: "svg-icon svg-icon-2x svg-icon-danger" }
const _hoisted_12 = { class: "fw-bold text-gray-900 mb-2" }
const _hoisted_13 = { class: "text-gray-600 fs-7" }
const _hoisted_14 = {
  key: 0,
  class: "d-flex align-items-start bg-light-danger border border-danger border-dashed rounded p-3 mb-5"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-octagon-fill text-danger fs-4 me-3 mt-1" }, null, -1)
const _hoisted_16 = { class: "fs-7 text-gray-800" }
const _hoisted_17 = {
  key: 1,
  class: "mb-5"
}
const _hoisted_18 = { class: "d-flex align-items-center fw-semibold text-gray-700 fs-7 mb-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "me-2" }, "Hồ sơ bị đánh dấu xóa", -1)
const _hoisted_20 = { class: "badge badge-light-danger" }
const _hoisted_21 = {
  class: "border border-gray-200 border-dashed rounded px-2",
  style: {"max-height":"180px","overflow-y":"auto"}
}
const _hoisted_22 = { class: "d-flex flex-column" }
const _hoisted_23 = { class: "fw-bold text-gray-900 fs-7" }
const _hoisted_24 = {
  key: 0,
  class: "text-gray-500 fs-8"
}
const _hoisted_25 = { class: "mb-6" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required fw-semibold fs-7" }, "Lý do xóa", -1)
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "d-flex justify-content-end gap-3" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "svg-icon svg-icon-3 me-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-success me-3 d-none",
      ref: "call_modal_delete",
      "data-bs-toggle": "modal",
      "data-bs-target": `#${_ctx.id}`
    }, null, 8, _hoisted_1),
    _createElementVNode("div", {
      class: "modal fade",
      id: _ctx.id,
      ref: "addDeleteModalRef",
      tabindex: "-1",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "ms-auto btn btn-icon btn-sm btn-active-light-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
            }, [
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen027.svg" })
                  ])
                ])
              ]),
              _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.title || 'Xác nhận xóa'), 1),
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.warningText || 'Vui lòng nhập lý do để xác nhận. Thao tác này là xóa mềm — có thể khôi phục lại.'), 1)
            ]),
            (_ctx.blockedText)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.blockedText), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.warningItems && _ctx.warningItems.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.warningItems.length), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warningItems, (it, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: _normalizeClass(["d-flex align-items-center justify-content-between py-2 px-1", i < _ctx.warningItems.length - 1 ? 'border-bottom border-gray-200 border-dashed' : ''])
                      }, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("span", _hoisted_23, _toDisplayString(it.code || it.label || it.name || it), 1),
                          (it.method || it.phase)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                _createTextVNode(_toDisplayString(it.method), 1),
                                (it.phase)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(" · Đợt " + _toDisplayString(it.phase), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (it.status && it.status.label)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(["badge fs-8", `badge-light-${it.status.state || 'secondary'}`])
                            }, _toDisplayString(it.status.label), 3))
                          : _createCommentVNode("", true)
                      ], 2))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control form-control-solid",
                rows: "3",
                disabled: !!_ctx.blockedText,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.comment_profile) = $event)),
                placeholder: "Nhập lý do xóa…"
              }, null, 8, _hoisted_27), [
                [_vModelText, _ctx.comment_profile]
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-light",
                "data-bs-dismiss": "modal",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeModal()))
              }, " Hủy bỏ "),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-danger",
                disabled: !!_ctx.blockedText || !_ctx.comment_profile || !_ctx.comment_profile.trim(),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submitComment()))
              }, [
                _createElementVNode("span", _hoisted_30, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen027.svg" })
                ]),
                _createTextVNode(" Xác nhận xóa ")
              ], 8, _hoisted_29)
            ])
          ])
        ])
      ])
    ], 8, _hoisted_2)
  ], 64))
}